import schema, { generateType, } from './Schema';
export const Kicker = generateType(schema.getModel('kicker'));
//# sourceMappingURL=KickerModel.js.map